import swipe from "../lib/swipe";
import parseHTML from "../lib/dom/funciones/parse_html";
var slider = function () {
    var sliders = Array.from(document.querySelectorAll('.slider'));
    sliders.forEach(function (slider) {
        var slides = Array.from(slider.querySelectorAll('.slide'));
        if (slides.length < 2) {
            return;
        }
        var actual = 0;
        var interval;
        var actualizaPosicion = function (sentido) { return function () {
            actual += sentido;
            if (actual < 0) {
                actual = slides.length - 1;
            }
            else if (actual >= slides.length) {
                actual = 0;
            }
            slider.style.setProperty('--slider-posicion', "".concat(actual));
            anterior.disabled = actual <= 0;
            siguiente.disabled = actual >= slides.length - 1;
        }; };
        var _a = ['Anterior', 'Siguiente'].map(function (texto, i) {
            var boton = parseHTML("<button class=\"slider__flecha slider__flecha-".concat(texto.toLowerCase(), "\">").concat(texto, "</button>"));
            boton.addEventListener('click', actualizaPosicion(i === 0 ? actual - 1 : actual + 1));
            boton.disabled = i === 0;
            return boton;
        }), anterior = _a[0], siguiente = _a[1];
        var avanza = actualizaPosicion(1);
        var retrocede = actualizaPosicion(-1);
        var contenedorDeFlechas = document.createElement('div');
        contenedorDeFlechas.classList.add('slider__flechas');
        contenedorDeFlechas.appendChild(anterior);
        contenedorDeFlechas.appendChild(siguiente);
        slider.appendChild(contenedorDeFlechas);
        swipe(slider, function () {
            window.clearInterval(interval);
            avanza();
        }, function () {
            window.clearInterval(interval);
            retrocede();
        });
    });
};
export default slider;
